import { render, staticRenderFns } from "./MovementMaterialTable.vue?vue&type=template&id=35d27164&"
import script from "./MovementMaterialTable.vue?vue&type=script&lang=js&"
export * from "./MovementMaterialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports